import { useAppSelector } from "features/store";

export interface PlatformRole {
  /** PlatformUser.is_superuser — may edit Settings and run the wizard. */
  isSuperuser: boolean;
  /** PlatformUser.is_calibrate_manager. */
  isCalibrateManager: boolean;
  /** Superuser OR calibrate manager — the integration-platform read/admin tier. */
  isAdmin: boolean;
  /** PlatformUser.is_developer — may see the integrations-beta UI (temporary
   * visibility gate while the frontend is unfinished; grants no backend rights). */
  isDeveloper: boolean;
}

/**
 * Current user's integration-platform role flags, mirroring the backend gates
 * (see api/core/permissions.py). Used to show/hide name editing, the Trigger
 * button, the "by trigger" history filter, Settings editing and the wizard.
 */
export function usePlatformRole(): PlatformRole {
  const profile = useAppSelector((state) => state.auth.user?.platform_profile);
  const isSuperuser = !!profile?.is_superuser && !profile?.is_archived;
  const isCalibrateManager =
    !!profile?.is_calibrate_manager && !profile?.is_archived;
  const isDeveloper = !!profile?.is_developer && !profile?.is_archived;
  return {
    isSuperuser,
    isCalibrateManager,
    isAdmin: isSuperuser || isCalibrateManager,
    isDeveloper,
  };
}
